import React from 'react';
import Item from './Item';
import { useSelectContext } from './SelectProvider';

const GroupItem = ({ item, primaryColor }) => {
  const { classNames, formatGroupLabel } = useSelectContext();

  return (
    <>
      {item.options.length > 0 && (
        <>
          {formatGroupLabel ? (
            <>{formatGroupLabel(item)}</>
          ) : (
            <div
              className={
                classNames?.listGroupLabel
                  ? classNames.listGroupLabel
                  : 'cursor-default select-none text-center bg-gray-100 border-b border-gray-200 truncate py-2 pr-2 font-bold text-gray-900'
              }
            >
              {item.label}
            </div>
          )}

          {item.options.map((item, index) => (
            <Item primaryColor={primaryColor} key={index} item={item} />
          ))}
        </>
      )}
    </>
  );
};

export default GroupItem;
